 

document.addEventListener("DOMContentLoaded", () => {
    
    function applyClassIfNotAU() {
        // Read country from Shopify storefront context
        const country = window.Shopify && typeof window.Shopify.country === 'string'
        ? window.Shopify.country.toUpperCase()
        : null;

        // Only apply if country is known and not AU
        if (country && country !== 'AU') {
        document.querySelectorAll('.page-width > .compare-product-chart-container')
            .forEach(el => el.classList.add('hide-last-item'));
        document.querySelectorAll('body.template-product-comparison-table feature-chart > .feature-chart__table > .feature-chart__table-row')
            .forEach(el => el.classList.add('hide-last-item'));  
        }
        document.querySelector('body.template-index div[id*="shopify-section-template--19447898996932__image_with_text_"]') && (document.querySelector('body.template-index div[id*="shopify-section-template--19447898996932__image_with_text_"]').style="display:none")
        
        // const sectionChatHeader = document.querySelectorAll('.compare-product-chart-container.hide-last-item > .content-container > .content-main > .icon-with-text-container ')
        // const sectionChatContent = document.querySelectorAll('.compare-product-chart-container.hide-last-item > .content-container > .content-main > .compare-product-chart-container > div')
        // sectionChatHeader && chatHeader.forEach(i=>i.style="grid-template-columns: 21% 40% 39%;")
        // sectionChatContent && chatContent.forEach(i=>i.style="grid-template-columns: 20% 40% 40%;")

        // const pageChatContent = document.querySelectorAll('body.template-product-comparison-table feature-chart > .feature-chart__table > .feature-chart__table-row')
        // setTimeout(()=>{pageChatContent && pageChatContent.forEach(i=>i.style="grid-template-columns: 20% 40% 40%;")}, 1000)

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyClassIfNotAU);
    } else {
        applyClassIfNotAU();
    }


    (function () {
        function update() {
            var mb;
            if (innerWidth < 750) {
            var qa = document.querySelector('product-rerender product-quick-add.is-visible');
            mb = qa ? qa.offsetHeight : 0;
            } else {
            mb = document.querySelector('#monster-upsell-sticky-cart .mu_sticky_visible') ? 70 : 0;
            }
            document.querySelectorAll('div[id^=alia-root]').forEach(function (el) {
            el.style.setProperty('margin-bottom', mb + 'px', 'important');
            });
        }
        new MutationObserver(update).observe(document.body, {
            subtree: true, childList: true, attributes: true, attributeFilter: ['class']
        });
        addEventListener('resize', update);
        update();
    })();

})


